<template>
    <div>
        <span :class="[{'blue--text': punkte[0] >= 3},
                {'success--text': punkte[0] >= 2 && punkte[0] < 3},
                {'primary--text': punkte[0] < 2},
                ]">{{punkte[0]}}</span> /
        <span :class="[{'blue--text': punkte[1] === 1},
                                    {'success--text': punkte[1] === 0.5},
                                    {'primary--text': punkte[1] === 0},
                                    ]">{{punkte[1]}}</span>
    </div>
</template>

<script>
    export default {
        name: "spieler-performance-sap-map",
        props: ['punkte']
    }
</script>

<style scoped>

</style>